import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useMediaQuery } from "@mui/material";
import { settings } from "app";
import {
  Labeled,
  ReferenceField,
  SimpleShowLayout,
  TextField,
  SelectField,
  useGetList,
  DateField,
  useNotify,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

import { administrationRequests } from "api/administrationApi";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { studentRequests } from "api/studentApi";
import { PreviousEducationType } from "utils/choices";
import { getFile } from "server/components/DownloadFile";
import AddPreviousEducationDocumentsModal from "components/Users/Students/Modals/AddPreviousEducationDocumentsModal";
import EditPreviousEducationInfoModal from "components/Users/Students/Modals/EditPreviousEducationInfoModal";

const PreviousEducationData = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const notify = useNotify();
  const { data } = useGetList(
    studentRequests.getStudentPreviousEducation(record?.studentId),
    {
      pagination: { page: 1, perPage: 999 },
      sort: { field: "id", order: "ASC" },
    },
    { enabled: !!record?.studentId },
  );

  return (
    <SimpleShowLayout>
      <Grid
        container
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Accordion sx={{ width: "100%" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
            <Typography
              color={"#4E2683"}
              sx={{ fontWeight: "bold" }}
            >
              Данни за предходно образование
            </Typography>
          </AccordionSummary>{" "}
          <AccordionDetails sx={{ width: "100%" }}>
            {data?.map((item, idx) => (
              <Grid
                key={`${item.id}-${idx}`}
                spacing={2}
                gap={6}
                container
                sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
              >
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Серия на диплома">
                    <TextField
                      record={item}
                      source="diplomaSeries"
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Рег. Номер на диплома">
                    <TextField
                      record={item}
                      source="diplomaRegistration"
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Сериен номер на диплома">
                    <TextField
                      record={item}
                      source="diplomaSerialNumber"
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Дата на диплома">
                    <DateField
                      locales="bg-BG"
                      record={item}
                      source="diplomaDate"
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Година на завършване">
                    <TextField
                      record={item}
                      source="graduationYear"
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Учебно заведение">
                    <TextField
                      record={item}
                      source="institution"
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Държава">
                    <ReferenceField
                      record={item}
                      source="countryId"
                      reference={administrationRequests.getCountriesSelect()}
                    >
                      <TextField source="nameBg" />
                    </ReferenceField>
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Град">
                    <ReferenceField
                      record={item}
                      source="settlementId"
                      reference={administrationRequests.getSettlementsSelect()}
                    >
                      <TextField
                        source="nameBg"
                        emptyText="-"
                      />
                    </ReferenceField>
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Тип образование">
                    <SelectField
                      record={item}
                      source="educationType"
                      choices={PreviousEducationType}
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Профил">
                    <TextField
                      record={item}
                      source="profession"
                      emptyText="-"
                    />
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  xl={2}
                >
                  <Labeled label="Квалификационна степен">
                    <ReferenceField
                      source="degreeId"
                      textAlign="center"
                      reference={administrationRequests.getDegreesSelect()}
                      record={item}
                    >
                      <TextField
                        source="name"
                        label="Квалификационна степен"
                      />
                    </ReferenceField>
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                  p={2}
                >
                  <SecuredComponent permission={permissions.canManageStudentPreviousEducation}>
                    <EditPreviousEducationInfoModal
                      record={record}
                      data={item}
                    />
                  </SecuredComponent>
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <Labeled label="Документи за предходно образование">
                    <>
                      {item?.diplomaDocumentsIds?.map(id => (
                        <Typography
                          key={id}
                          sx={{
                            textDecoration: "underline",
                            fontSize: "14px",
                            cursor: "pointer",
                            mb: 1,
                          }}
                          onClick={() => getFile(id, notify)}
                        >
                          {`file-${id}.pdf`}
                        </Typography>
                      ))}
                    </>
                  </Labeled>
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <AddPreviousEducationDocumentsModal
                    studentId={record?.studentId}
                    id={item?.id}
                  />
                </Grid>
              </Grid>
            ))}
          </AccordionDetails>
        </Accordion>
      </Grid>
    </SimpleShowLayout>
  );
};
export default PreviousEducationData;
